'use client'
import { Link, Outlet } from 'react-router-dom'
import { useState, useEffect } from 'react'
import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    TransitionChild,
} from '@headlessui/react'

import { getCategoriesToolConnections } from 'api/agents'
import {
    XMarkIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
} from '@heroicons/react/24/outline'
import Sidebar from './Sidebar'
import useAuth from 'hooks/useAuth'
import { useLocation } from 'react-router-dom'
import useSocket from 'hooks/useSocket'
import useNotifier from 'utils/useNotifier'
import { useSelector } from 'react-redux'
import ChatHistory from './pages/assistant/ChatHistory'
import TableAssistant from './pages/assistant/TableAssistant'
import { dispatch } from 'store'
// const userNavigation = [
//     { name: 'Your profile', href: '/dashboard/user/account' },
//     { name: 'Sign out', href: '/auth/logout' },
// ]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function DashboardLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false) // New state for sidebar collapse
    const { pathname } = useLocation()
    const { user } = useAuth()
    const isAssistantOpen = useSelector((state) => state.chat.navItemClicked)
    useNotifier()
    useSocket(user)
    useEffect(() => {
        getCategoriesToolConnections()
    }, [])
    const isTable = pathname.includes('/dashboard/table/')
    let hideNav = isTable || pathname.includes('/dashboard/task-flow-assistant')
    useEffect(() => {
        if (pathname.includes('/dashboard/table/')) {
            setSidebarCollapsed(true)
            dispatch({ type: 'NAV_ITEM_CLICKED', payload: { name: 'Assistant' } })
        } else if (pathname.includes('/dashboard/task-flow-assistant')) {
            setSidebarCollapsed(true)
        } else {
            dispatch({ type: 'NAV_ITEM_CLICKED', payload: null })
            setSidebarCollapsed(false)
        }
    }, [pathname])

    return (
        <>
            <div>
                <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-10 lg:hidden">
                    <DialogBackdrop
                        transition
                        className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
                    />

                    <div className="fixed inset-0 flex">
                        <DialogPanel
                            transition
                            className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
                        >
                            <TransitionChild>
                                <div className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
                                    <button type="button" onClick={() => setSidebarOpen(false)} className="-m-2.5 p-2.5">
                                        <span className="sr-only">Close sidebar</span>
                                        <XMarkIcon aria-hidden="true" className="size-6 text-white" />
                                    </button>
                                </div>
                            </TransitionChild>
                            {/* Sidebar component, swap this element with another sidebar if you like */}
                            <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
                                <div className="flex h-16 shrink-0 items-center">
                                    <img alt='Meerkats.ai' src='/logo/logo.svg'
                                        className="h-8 w-auto"
                                    />
                                </div>
                                <Sidebar />
                            </div>
                        </DialogPanel>
                    </div>
                </Dialog>
                <div className='h-screen w-screen flex flex-col bg-white'>
                    <div className='flex flex-row h-screen '>
                        <div className={classNames(
                            "hidden lg:fixed lg:inset-y-0 lg:z-10 lg:flex lg:flex-col transition-all duration-300 ease-in-out border-r border-gray-200 bg-gray-50",
                            sidebarCollapsed ? "w-[56px]" :hideNav ?  "w-[400px]" : "w-[300px]"
                        )}>
                            {hideNav ? null :
                                <button
                                    onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                                    className="absolute -right-3 top-6 z-20 bg-white border border-gray-200 rounded-full p-1 shadow-md hover:shadow-lg transition-shadow"
                                >
                                    {sidebarCollapsed ? (
                                        <ChevronRightIcon className="h-4 w-4 text-gray-600" />
                                    ) : (
                                        <ChevronLeftIcon className="h-4 w-4 text-gray-600" />
                                    )}
                                </button>
                            }
                            <div className={classNames(
                                "flex grow flex-col gap-y-5 overflow-y-hidden py-4 ",
                                sidebarCollapsed ? "px-0" : "px-4"
                            )}>
                                {
                                    sidebarCollapsed ? (
                                        <div className="flex h-10 shrink-0 items-center pl-4">
                                            <Link to='/dashboard'>
                                                <img alt='Meerkats.ai' src={
                                                    sidebarCollapsed ? '/logo/m.svg' : '/logo/logo.svg'
                                                }
                                                    className="h-5 w-auto"
                                                />
                                            </Link>
                                        </div>
                                    ) :

                                        <div className="flex h-10 shrink-0 items-center pl-3">
                                            <Link to='/dashboard'>
                                                <img alt='Meerkats.ai' src={
                                                    sidebarCollapsed ? '/logo/m.svg' : '/logo/logo.svg'
                                                }
                                                    className="h-8 w-auto"
                                                />
                                            </Link>
                                        </div>
                                }
                                <Sidebar collapsed={sidebarCollapsed} pathname={pathname} />



                            </div>
                        </div>
                        {isAssistantOpen && hideNav ? (
                            <div className={classNames(
                                "hidden lg:fixed lg:inset-y-0 lg:z-10 lg:flex lg:flex-col transition-all duration-300 ease-in-out border-r border-gray-200 w-[400px] ml-14"
                            )}>
                                <div className={classNames(
                                    "flex grow flex-col overflow-y-hidden ",
                                )}>
                                    {
                                        isTable ? <TableAssistant /> :
                                            <ChatHistory />
                                    }
                                </div>
                            </div>) : null}
                        {
                            hideNav ?
                                <main
                                    className={classNames(
                                        'overflow-y-auto transition-all duration-300 ease-in-out',
                                        isAssistantOpen ? 'ml-[456px] w-[calc(100%-456px)]' : 'ml-[56px] w-[calc(100%-56px)]'
                                    )}
                                >
                                    <div className='h-full w-full '>
                                        <Outlet />
                                    </div>
                                </main> :
                                <main
                                    className={classNames(
                                        'overflow-y-auto transition-all duration-300 ease-in-out p-4',
                                        sidebarCollapsed ? 'ml-[56px] w-[calc(100%-56px)]' : 'ml-[300px] w-[calc(100%-300px)]',
                                    )}
                                >
                                    <div className='h-full w-full '>
                                        <Outlet />
                                    </div>
                                </main>
                        }

                    </div>
                </div>
            </div>
        </>
    )
}
